import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';

import { EmptyTool, PanTool } from './tools';

export function registerPointerViewing(context: ViewExtensionContext) {
  context.register(EmptyTool);
  context.register(PanTool);
}
export class PointerViewingExtension extends ViewExtensionProvider {
  override name = 'pointer-viewing';
  override setup(context: ViewExtensionContext) {
    super.setup(context);
    registerPointerViewing(context);
  }
}
